import React from "react";

import { Box, Button, Typography } from "@mui/material";

class MainTabButton extends React.Component {
    constructor(props) {
        super(props)
    }

    // render() {
    //     return (
    //         <Box
    //             display='flex'
    //             justifyContent='center'
    //             borderRadius='5px'
    //             backgroundColor={this.props.colors.custom['secondaryButton']}
    //             onClick={this.props.onButtonClick}
    //             height='100%'
    //             {...this.props}
    //             sx={{
    //                 width: width,
    //                 borderRadius: borderRadius,
    //                 opacity: disabled ? 0.5 : 1,
    //                 cursor: disabled ? 'not-allowed' : 'pointer',
    //                 ...sx,
    //             }}
    //         >
    //             <Button {...this.props} sx={{ width: '100%' }} disabled={this.props.disabled}><Typography sx={{ color: this.props.colors.custom['colorWhite'], fontWeight: '500', letterSpacing: '2px' }}>{this.props.title}</Typography></Button>
    //         </Box>
    //     )
    // }
    render() {
        const { sx, onFocus, disabled, width } = this.props // Incluindo a propriedade disabled

        const borderRadius = sx?.borderRadius || '5px';
        const textColor = sx?.textColor || 'white';
        var width2 = sx?.width || '100%';
        width2 = width || '100%';

        return (
            <Box
                display='flex'
                justifyContent='center'
                onClick={(e) => {
                    if (disabled) {
                        e.stopPropagation()
                    } else {
                        this.props.onButtonClick()
                    }
                }}
                height='40px'
                sx={{
                    width: width2,
                    borderRadius: borderRadius,
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    ...sx,
                }}
                backgroundColor={this.props.colors.custom['secondaryButton']}
            >
                <Button
                    ref={this.props.innerRef}
                    sx={{ width: '100%', borderRadius: borderRadius }}
                    id={this.props.id}
                    onFocus={(params) => onFocus ? onFocus(params) : null}
                    disabled={disabled}
                >
                    <Typography
                        sx={{ color: textColor, fontWeight: '500', letterSpacing: '1px', textTransform: 'none' }}
                    >
                        {this.props.title}
                    </Typography>
                </Button>
            </Box>
        )
    }
}

export default MainTabButton;